import styles from './section-footer.css';
import Footer from './footer';

<template>
  <section class={{styles.footer}} ...attributes>
    <Footer />
  </section>
</template>
